import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "./Config";
import DatePicker from "./DatePicker";

export default function RegisterForm({ showToast }) {
  const [formData, setFormData] = useState({
    user_name: "",
    password: "",
    full_name: "",
    date_of_birth: "",
    gender: "",
    sport: "",
    org_id: "",
  });

  const [status, setStatus] = useState("");
  const [toast, setToast] = useState("");
  const [orgOptions, setOrgOptions] = useState([]);
  const [successCard, setSuccessCard] = useState({ show: false, message: "" });
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const fetchOrganizations = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const response = await fetch(
        `${BASE_URL}/api/organization/get_organizations`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!response.ok) throw new Error("Failed to fetch organizations");
      const data = await response.json();
      setOrgOptions(data);
    } catch (err) {
      setOrgOptions([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      date_of_birth: e.target.value,
    }));
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${BASE_URL}/api/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const result = await response.json();
      if (response.ok) {
        setSuccessCard({ show: true, message: result.message || "Registration successful!" });
        setFormData({
          user_name: "",
          password: "",
          full_name: "",
          date_of_birth: "",
          gender: "",
          sport: "",
          org_id: "",
        });
        setTimeout(() => {
          setSuccessCard({ show: false, message: "" });
          navigate("/");
        }, 2000);
      } else {
        setSuccessCard({ show: true, message: result.message || "Registration failed." });
        setTimeout(() => {
          setSuccessCard({ show: false, message: "" });
        }, 2000);
      }
    } catch (error) {
      showToast("Network or server error. Please try again.", "error");
    }
  };

  return (
    <>
      {successCard.show && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.18)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 16,
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            padding: '2.5rem 2.5rem 2rem 2.5rem',
            minWidth: 340,
            maxWidth: 400,
            textAlign: 'center',
            fontFamily: 'Poppins, Segoe UI, sans-serif',
          }}>
            <h2 style={{ color: '#11998e', fontWeight: 700, fontSize: 24, marginBottom: 12 }}>Registration</h2>
            <div style={{ color: '#444', fontSize: 18, marginBottom: 8 }}>{successCard.message}</div>
            <div style={{ color: '#888', fontSize: 14 }}>Redirecting...</div>
          </div>
        </div>
      )}
      {toast && (
        <div className="fixed top-8 left-1/2 transform -translate-x-1/2 bg-teal-500 text-white px-8 py-4 rounded-lg text-lg z-50 shadow-lg animate-fade-in">
          {toast}
        </div>
      )}
      <form className="space-y-4 hide-scrollbar" onSubmit={handleRegister} style={{width: '100%', marginTop: 0, padding: 0, boxSizing: 'border-box', maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none'}}>
        <div>
          <label htmlFor="user_name" style={{fontSize:'16px', color:'rgba(75, 75, 75, 1)', lineHeight:'150%', display:'block', marginBottom:'4px'}}>Username</label>
          <input
            id="user_name"
            type="text"
            name="user_name"
            placeholder="Enter username"
            value={formData.user_name}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              height: '53px',
              opacity: 1,
              borderRadius: '8px',
              padding: '16px',
              borderWidth: '1px',
              border: '1px solid rgba(221, 221, 221, 1)',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.2s',
              marginBottom: '8px',
              boxSizing: 'border-box'
            }}
            className="focus:border-teal-500"
          />
        </div>
        <div>
          <label htmlFor="full_name" style={{fontSize:'16px', color:'rgba(75, 75, 75, 1)', lineHeight:'150%', display:'block', marginBottom:'4px'}}>Full Name</label>
          <input
            id="full_name"
            type="text"
            name="full_name"
            placeholder="Enter full name"
            value={formData.full_name}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              height: '53px',
              opacity: 1,
              borderRadius: '8px',
              padding: '16px',
              borderWidth: '1px',
              border: '1px solid rgba(221, 221, 221, 1)',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.2s',
              marginBottom: '8px',
              boxSizing: 'border-box'
            }}
            className="focus:border-teal-500"
          />
        </div>
        <div>
          <label htmlFor="password" style={{fontSize:'16px', color:'rgba(75, 75, 75, 1)', lineHeight:'150%', display:'block', marginBottom:'4px'}}>Password</label>
          <input
            id="password"
            type="password"
            name="password"
            placeholder="Enter password"
            value={formData.password}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              height: '53px',
              opacity: 1,
              borderRadius: '8px',
              padding: '16px',
              borderWidth: '1px',
              border: '1px solid rgba(221, 221, 221, 1)',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.2s',
              marginBottom: '8px',
              boxSizing: 'border-box'
            }}
            className="focus:border-teal-500"
          />
        </div>
        <div>
          <label htmlFor="date_of_birth" style={{fontSize:'16px', color:'rgba(75, 75, 75, 1)', lineHeight:'150%', display:'block', marginBottom:'4px'}}>Date of Birth</label>
          <div style={{width:'100%'}}>
            <DatePicker
              value={formData.date_of_birth}
              onChange={handleDateChange}
              placeholder="Select your date of birth"
              required
            />
          </div>
        </div>
        <div>
          <label htmlFor="gender" style={{fontSize:'16px', color:'rgba(75, 75, 75, 1)', lineHeight:'150%', display:'block', marginBottom:'4px'}}>Gender</label>
          <select
            id="gender"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              height: '53px',
              opacity: 1,
              borderRadius: '8px',
              padding: '16px',
              borderWidth: '1px',
              border: '1px solid rgba(221, 221, 221, 1)',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.2s',
              marginBottom: '8px',
              background: '#fff',
              boxSizing: 'border-box'
            }}
            className="focus:border-teal-500"
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div>
          <label htmlFor="sport" style={{fontSize:'16px', color:'rgba(75, 75, 75, 1)', lineHeight:'150%', display:'block', marginBottom:'4px'}}>Sport</label>
          <input
            id="sport"
            type="text"
            name="sport"
            placeholder="Enter sport"
            value={formData.sport}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              height: '53px',
              opacity: 1,
              borderRadius: '8px',
              padding: '16px',
              borderWidth: '1px',
              border: '1px solid rgba(221, 221, 221, 1)',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.2s',
              marginBottom: '8px',
              boxSizing: 'border-box'
            }}
            className="focus:border-teal-500"
          />
        </div>
        <div>
          <label htmlFor="organization" style={{fontSize:'16px', color:'rgba(75, 75, 75, 1)', lineHeight:'150%', display:'block', marginBottom:'4px'}}>Organization</label>
          <select
            id="org_id"
            name="org_id"
            value={formData.org_id}
            onChange={handleChange}
            required
            style={{
              width: '100%',
              height: '53px',
              opacity: 1,
              borderRadius: '8px',
              padding: '16px',
              borderWidth: '1px',
              border: '1px solid rgba(221, 221, 221, 1)',
              fontSize: '16px',
              outline: 'none',
              transition: 'border-color 0.2s',
              marginBottom: '8px',
              background: '#fff',
              boxSizing: 'border-box'
            }}
            className="focus:border-teal-500"
          >
            <option value="">Select Organization</option>
            {orgOptions.map((org) => (
              <option key={org.org_id} value={org.org_id}>
                {org.name}
              </option>
            ))}
          </select>
        </div>
        
        <div style={{ paddingBottom: '16px' }}>
          <div style={{width: '100%', marginBottom: 16}}>
            <button 
              type="submit" 
              className="text-white font-semibold transition-all duration-300 w-full"
              style={{
                width: '100%',
                height: '40px',
                opacity: 1,
                borderRadius: '8px',
                background: 'rgba(15, 150, 144, 1)',
                border: 'none',
                outline: 'none',
                fontSize: 16,
                fontWeight: 600
              }}
            >
              REGISTER
            </button>
          </div>
          {status && <p className="mt-4 text-center text-sm text-gray-600">{status}</p>}
        </div>
      </form>
    </>
  );
}
